/**
 * @file 회사소개 화면 Data
 */

/**
 * @constant COMPANY_DESC_INFO desc data
 * @type imgUrl 이미지url
 */
export const COMPANY_DESC_INFO = [
    {
        imgUrl: require('assets/images/company/img-company-slide1-photo1.png'),
    },
    {
        imgUrl: require('assets/images/company/img-company-slide1-photo4.png'),
    },
    {
        imgUrl: require('assets/images/company/img-company-slide1-photo3.png'),
    },
]
